<template>
    <navigation-rail variant="drawer" background-color="gray-100">
        <template #header>
            <flex-container
                align-items="center"
                :padding="Size.md"
                :gap="Size.sm"
            >
                <back-button
                    :to="{ name: 'assistent-dashboard' }"
                />
                <text-decorator color="gray-500" bold>
                    Instellingen
                </text-decorator>
            </flex-container>
        </template>
        <template #default>
            <assistent-menu-item
                :to="{ name: 'assistent-chat-edit-personality' }"
                title="Persoonlijkheid"
            />
            <assistent-menu-item
                :to="{ name: 'assistent-chat-edit-advanced' }"
                title="Geavanceerd"
                hide-active-state
            />
            <flex-container
                v-if="dropdownVisible"
                direction="column"
                align-content="flex-end"
                :padding-right="Size.md"
                :gap="Size.sm"
            >
                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-functionality' }"
                    title="Functionaliteiten"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-options' }"
                    title="Snelle opties"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-knowledge' }"
                    title="Kennis"
                />

                <!--                    <assistent-menu-item-->
                <!--                        :to="{ name: 'assistent-chat-edit-flows' }"-->
                <!--                        title="Flows"-->
                <!--                    />-->

                <!--                    <assistent-menu-item-->
                <!--                        :to="{ name: 'assistent-chat-edit-realworks' }"-->
                <!--                        title="Realworks"-->
                <!--                    />-->

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-display' }"
                    title="Weergave"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-chat-connect' }"
                    title="ChatConnect"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-instruction' }"
                    title="Instructie"
                    chip-title="Expert"
                    :chip-color="chipColor"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-handover' }"
                    title="Handover"
                />

                <assistent-menu-item
                    :to="{ name: 'assistent-chat-edit-embed-code' }"
                    title="Embed Code"
                />

                <horizontal-line :style="{ width: '80%' }" no-margin />
                <assistent-delete-item title="AI Agent verwijderen" />
            </flex-container>
        </template>
        <template #footer>
            <slot />
        </template>
    </navigation-rail>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { FlexContainer, Size } from '@keyvue/one-ui';
    import AssistentMenuItem from '@/ai/assistent/components/AssistentMenuItem.vue';
    import { useRouter } from 'vue-router';
    import useAppBranding from '@/services/app-branding/composables/useAppBranding';
    import BackButton from '@/shared/components/BackButton.vue';

    import AssistentDeleteItem from '@/ai/assistent/components/AssistentDeleteMenuItem.vue';

    const router = useRouter();
    const { hasHeylohaBranding } = useAppBranding();

    const dropdownVisible = computed(() => {
        return [
            'assistent-chat-edit-functionality',
            'assistent-chat-edit-knowledge',
            'assistent-chat-edit-display',
            'assistent-chat-edit-instruction',
            'assistent-chat-edit-handover',
            'assistent-chat-edit-options',
            'assistent-chat-edit-embed-code',
            'assistent-chat-edit-chat-connect',
            'assistent-chat-edit-chat-connect-goal',
            'assistent-chat-edit-chat-connect-system-goals',
        ].includes(router?.currentRoute?.value?.name?.toString() ?? '');
    });

    const chipColor = computed(() => {
        return hasHeylohaBranding() ? '#EF7D62' : 'primary';
    });
</script>
